<template>
  <div
    style="width: 100%; height: 100%"
    class="pa-5"
  >
    <div>
      <h1 class="title ma-1">
        Поставка <span class="font-weight-bold">№ {{ title }}</span>
      </h1>
      <h2 class="subheading ma-1">
        Статус: <span class="font-weight-bold">{{ state.title }}</span>
      </h2>
      <h2 class="subheading ma-1">
        Поставки из того же региона:
        <span class="font-weight-bold">{{ sameRegionShipping }}</span>
      </h2>
    </div>
    <div>
      <v-layout column>
        <v-flex>
          <v-layout>
            <v-flex xs7>
              <h2 class="subheading font-weight-bold mt-2">
                Информация о поставке
              </h2>
              <v-list class="info-list">
                <template v-for="(group, gIndex) in infoItems">
                  <v-subheader
                    :key="gIndex"
                    class="pr-0 ma-2"
                  >
                    {{ group.title }}
                  </v-subheader>
                  <v-list-tile
                    v-for="(property, index) in group.items"
                    :key="index.toString() + gIndex.toString()"
                    class="compact px-0"
                  >
                    <v-layout
                      v-if="property.type != 'array'"
                      row
                      align-center
                      justify-start
                    >
                      <v-flex xs4>
                        <span>{{ property.title }}:</span>
                      </v-flex>
                      <v-flex sx8>
                        {{ property.value }}
                      </v-flex>
                    </v-layout>
                    <v-layout
                      v-else
                      column
                    >
                      <v-list
                        v-for="(items, index) in property.value"
                        :key="index"
                        :class="index > 0 ? 'pb-1 pt-0' : 'py-1'"
                      >
                        <v-list-tile
                          v-for="(item, index) in items"
                          :key="index"
                          class="compact px-0"
                        >
                          <v-layout row>
                            <v-flex xs6>
                              <span>{{ item.title }}:</span>
                            </v-flex>
                            <v-flex xs6>
                              <span>{{ item.value }}</span>
                            </v-flex>
                          </v-layout>
                        </v-list-tile>
                      </v-list>
                    </v-layout>
                  </v-list-tile>
                </template>
              </v-list>
            </v-flex>
            <v-divider
              vertical
              class="mx-3"
            />
            <v-flex xs5>
              <v-layout column>
                <v-flex>
                  <h2 class="subheading font-weight-bold mt-2">
                    Даты
                  </h2>
                  <v-data-table
                    hide-actions
                    :headers="datesHeaders"
                    :items="datesItems"
                    class="elevation-0 pa-1 ma-2"
                  >
                    <template
                      slot="headers"
                      slot-scope="props"
                    >
                      <tr class="text-xs-left">
                        <th
                          v-for="header in props.headers"
                          :key="header.text"
                          class="pa-1"
                        >
                          {{ header.text }}
                        </th>
                      </tr>
                    </template>
                    <template
                      slot="items"
                      slot-scope="props"
                    >
                      <td>{{ props.item.name }}</td>
                      <td>
                        <span v-if="!props.item.request">&mdash;</span>
                        <span
                          v-else-if="
                            typeof props.item.request.value !== 'object'
                          "
                        >{{ props.item.request.value | date }}</span>
                        <span
                          v-else-if="
                            typeof props.item.request.value === 'object'
                          "
                        >{{ props.item.request.value | dateRange }}</span>
                        <span v-else>{{
                          props.item.request.value | date
                        }}</span>
                      </td>

                      <td>
                        <span
                          v-if="typeof props.item.plan.value !== 'object'"
                        >{{ props.item.plan.value | date }}</span>
                        <span
                          v-else-if="typeof props.item.plan.value === 'object'"
                        >{{ props.item.plan.value | dateRange }}</span>
                        <span v-else>{{ props.item.plan.value | date }}</span>
                      </td>

                      <td>
                        <span
                          v-if="typeof props.item.fact.value !== 'object'"
                        >{{ props.item.fact.value | date }}</span>
                        <span
                          v-else-if="typeof props.item.fact.value === 'object'"
                        >{{ props.item.fact.value | dateRange }}</span>
                        <span v-else>{{ props.item.fact.value | date }}</span>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-divider class="my-3" />
                <v-flex>
                  <v-layout column>
                    <v-flex v-if="activeTab === 0">
                      <h2 class="subheading font-weight-bold mt-2">
                        Сообщения
                      </h2>
                      <v-list class="ma-2">
                        <v-list-tile
                          v-for="item in messages"
                          :key="item.id"
                          class="compact"
                        >
                          <v-list-tile-content>
                            <div>{{ item.text }}</div>
                            <v-list-tile-sub-title>
                              {{ item.author ? item.author.title : "" }}:
                              {{ item.date | dateTime }}
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                    <v-flex v-if="activeTab === 1">
                      <h2 class="subheading font-weight-bold mt-2">
                        Заметки
                      </h2>
                      <v-list>
                        <v-list-tile
                          v-for="item in notes"
                          :key="item.id"
                        >
                          <v-list-tile-content>
                            <div>
                              <span
                                style="color: rgba(0,0,0,.54);"
                              >{{ item.author }}: {{ item.date | dateTime }}
                              </span>
                              <span> {{ item.text }}</span>
                            </div>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                    <v-flex v-if="activeTab === 2">
                      <h2 class="subheading font-weight-bold mt-2">
                        Документы
                      </h2>
                      <v-list class="ma-2">
                        <v-list-tile
                          v-for="(item, index) in attachments"
                          :key="index"
                          class="compact"
                        >
                          <v-list-tile-content>
                            <v-list-tile-title
                              v-text="
                                disabledUploadToServer
                                  ? item.originName
                                  : item.title
                              "
                            />
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-divider class="my-3" />
                <v-flex>
                  <h2 class="subheading font-weight-bold mt-2">
                    Метки
                  </h2>
                  <v-list class="ma-2">
                    <v-list-tile
                      v-for="(label, index) in labels"
                      :key="index"
                      class="compact"
                    >
                      <v-list-tile-content class="label-title pr-1 py-1">
                        {{ lables[label.name].title }}
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-layout
                          justify-end
                          align-center
                        >
                          <span
                            class="caption grey--text text--lighten-1 label-author"
                          >{{ label.author | shortName }}</span>
                          <v-chip
                            v-if="lables[label.name].variants"
                            label
                            small
                          >
                            {{ getVariantTitle(label) }}
                          </v-chip>
                          <v-chip
                            v-else
                            label
                            small
                          >
                            {{
                              getVariantTitleForGroup(
                                label.value[0],
                                label.name
                              )
                            }}
                          </v-chip>
                        </v-layout>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-divider
          horizontal
          class="my-3"
        />
        <v-flex>
          <v-layout
            column
            class="mt-3"
          >
            <v-layout>
              <h2 class="subheading font-weight-bold">
                Звенья
              </h2>
              <v-spacer />
              <span class="font-weight-bold">Направление*: {{ country }}</span>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  class="elevation-0"
                  :headers="phasesHeaders"
                  :items="phases"
                  hide-actions
                  no-data-text="Нет данных"
                >
                  <template
                    slot="headers"
                    slot-scope="props"
                  >
                    <tr class="text-xs-left px-3">
                      <th
                        v-for="(header, index) in props.headers"
                        :key="index"
                      >
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template
                    slot="items"
                    slot-scope="props"
                  >
                    <tr>
                      <td>
                        {{
                          props.item.state.id === 1
                            ? "В ожидании"
                            : props.item.state.id === 2
                              ? "В процессе"
                              : "Выполнено"
                        }}
                      </td>
                      <td>
                        {{
                          props.item.type.id === 1
                            ? "Заезд"
                            : props.item.type.id === 2
                              ? "Нестандарт"
                              : "Свозка"
                        }}
                      </td>
                      <td>
                        {{
                          props.item.arrivalPoint.factory
                            ? props.item.arrivalPoint.factory.title
                            : props.item.arrivalPoint.warehouse
                              ? props.item.arrivalPoint.warehouse.title
                              : ""
                        }}
                      </td>
                      <td>{{ props.item.arrivalPoint.address.title }}</td>
                      <td>{{ props.item.unloadingDate | date }}</td>
                      <td>
                        {{
                          props.item.sendingPoint.factory
                            ? props.item.sendingPoint.factory.title
                            : props.item.sendingPoint.warehouse
                              ? props.item.sendingPoint.warehouse.title
                              : ""
                        }}
                      </td>
                      <td>{{ props.item.sendingPoint.address.title }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-flex>
        <v-flex>
          <h2 class="subheading font-weight-bold mt-3">
            Отгрузки
          </h2>
          <v-flex xs12>
            <v-data-table
              class="elevation-0"
              :headers="releaseOrdersHeaders"
              :items="releaseOrders"
              hide-actions
              no-data-text="Нет данных"
            >
              <template
                slot="headers"
                slot-scope="props"
              >
                <tr class="text-xs-left px-3">
                  <th
                    v-for="(header, index) in props.headers"
                    :key="index"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template
                slot="items"
                slot-scope="props"
              >
                <tr>
                  <td>{{ props.item.releaseOrderPlan | date }}</td>
                  <td>{{ props.item.volume }}</td>
                  <td>{{ props.item.cargoPlaces }}</td>
                  <td>{{ props.item.number }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import lables from "../components/labels/lables.js";
export default {
  props: ["state", "activeTab"],
  data() {
    return {
      lables,
      items: [
        {
          value: false,
          name: "Готовность к отгрузке",
          request: { value: "", editable: true },
          plan: { value: "" },
          fact: { value: "" },
        },
        {
          value: false,
          name: "Доставка к месту выгрузки",
          request: { value: "" },
          plan: { value: "" },
          fact: { value: "" },
        },
        {
          value: false,
          name: "Отгрузка со склада Киев",
          plan: { value: "", editable: true },
          fact: { value: "" },
        },
      ],
    };
  },
  computed: {
    title() {
      return this.$store.getters["shipping/title"];
    },
    labels() {
      return this.$store.getters["shipping/labels"];
    },
    dates() {
      return this.$store.getters["shipping/dates"];
    },
    datesItems() {
      if (this.dates.readyToLoadDates) {
        const readyToLoadRow = this.items[0];
        readyToLoadRow.request.value =
          this.dates.readyToLoadDates.request || "";
        readyToLoadRow.plan.value = this.dates.readyToLoadDates.plan || "";
        readyToLoadRow.fact.value = this.dates.readyToLoadDates.fact || "";
      }
      if (this.dates.deliveryToUnloading) {
        const deliveryToUnloading = this.items[1];
        deliveryToUnloading.request.value =
          this.dates.deliveryToUnloading.request || "";
        deliveryToUnloading.plan.value =
          this.dates.deliveryToUnloading.plan || "";
        deliveryToUnloading.fact.value =
          this.dates.deliveryToUnloading.fact || "";
      }
      if (this.dates.shipmentFromStoreKiev) {
        const shipmentFromStoreKiev = this.items[2];
        shipmentFromStoreKiev.plan.value =
          this.dates.shipmentFromStoreKiev.plan || "";
        shipmentFromStoreKiev.fact.value =
          this.dates.shipmentFromStoreKiev.fact || "";
      }

      return [...this.items];
    },
    datesHeaders() {
      return this.$store.getters["shipping/datesHeaders"];
    },
    phasesHeaders() {
      return this.$store.getters["shipping/phasesHeaders"];
    },
    phases() {
      return this.$store.getters["shipping/phases"];
    },
    releaseOrders() {
      return this.$store.getters["shipping/releaseOrders"];
    },
    releaseOrdersHeaders() {
      return this.$store.getters["shipping/releaseOrdersHeaders"];
    },
    messages() {
      return this.$store.getters["shipping/messages"];
    },
    notes() {
      return this.$store.getters["shipping/notes"];
    },
    attachments() {
      return this.$store.getters["shipping/attachments"];
    },
    sameRegionShipping() {
      return this.$store.getters["shipping/sameRegionShipping"];
    },
    infoItems() {
      return this.$store.getters["shipping/infoItems"];
    },
    country() {
      return this.$store.getters["shipping/direction"].Title;
    },
  },
  mounted() {
    window.print();
    this.$emit("close", false);
  },
  methods: {
    getVariantTitle(labelValue) {
      return this.lables[labelValue.name].variants.find(
        v => v.id === this.lables[labelValue.name].value,
      ).title;
    },
    getVariantTitleForGroup(label, groupName) {
      const group = this.lables[groupName];
      return group.value[label.name].variants.find(v => v.id === label.value)
        .title;
    },
  },
};
</script>
